import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { usePermission } from "../../../../context/PermissionContext";
import AddSignature from "./AddSignature";
import InvoiceTempPreview from "./InvoiceTempPreview";
import handleError from "../../../../constants/handleError";
import AxiosInstance from "../../../../utils/AxiosInstance";
import { useAuth } from "../../../../context/AuthProvider";
import { useNetwork } from "../../../../context/NetworkContext";
import uRLs from "../../../../utils/baseUtils";
import { useShowAlert } from "../../../../context/AlertContext";
import InvoiceThumnail1 from "./templates_a4/InvoiceThumnail1";
import InvoiceThumnail2 from "./templates_a4/InvoiceThumnail2";
import InvoiceThumbnail from "./InvoiceThumbnail";
import InvoiceThumnail3 from "./templates_a4/InvoiceThumnail3";
import Thermal_1 from "./thermal_printer_temps/Thermal_1";
import Thermal_2 from "./thermal_printer_temps/Thermal_2";
import InvoiceThumnail4 from "./templates_a4/InvoiceThumnail4";
import ThermalTempPreview from "./ThermalTempPreview";
import InvoiceThumnail5 from "./templates_a4/InvoiceThumnail5";
import InvoiceThumnail6 from "./templates_a4/InvoiceThumnail6";
import InvoiceThumnail7 from "./templates_a4/InvoiceThumnail7";
import InvoiceThumnail8 from "./templates_a4/InvoiceThumnail8";
import HalfA4_1 from "./templates_halfA4/HalfA4_1";
import InvoiceHalfA4TempPreview from "./InvoiceHalfA4TempPreview";
import HalfA4_2 from "./templates_halfA4/HalfA4_2";
import HalfA4_3 from "./templates_halfA4/HalfA4_3";
import HalfA4_4 from "./templates_halfA4/HalfA4_4";
import HalfA4_5 from "./templates_halfA4/HalfA4_5";
import { FormatedTemplateData } from "../../../../templates/templateDataHandler";
import { getInvoiceConfig } from "../../../../templates/modules/getInvoiceConfig";
import { CheckIcon, EditBxIcon, PlusIcon, TrashIcon } from "../../../../constants/Icons";

const InvoiceSettings = () => {
  const showAlert = useShowAlert();
  const { setGlobelPopupOpen } = usePermission();
  const { updateSettings } = useAuth();
  const { storeSettings } = usePermission();
  const [terms, setTerms] = useState([]); // Store terms
  const [text, setText] = useState("");
  const [isEditing, setIsEditing] = useState(true); // true = editable mode
  const { checkNetwork } = useNetwork();
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isHalfA4ModalOpen, setHalfA4ModalOpen] = useState(false);
  const [isThermalViewModalOpen, setThermalViewModalOpen] = useState(false);;
  const { settings } = useAuth();
  
const sale =  {
        "_id": "6a83cd36e7c6c990d813eabd",
        "mainStoreId": "682ac1bd2767ad8156909395",
        "storeid": "682ac1bd2767ad8156909395",
        "saleno": "A262728",
        "saledate": "2026-08-18T03:10:46.931Z",
        "salemode": "INVOICE",
        "saletype": "B2C",
        "salefromid": "682ac1bd2767ad8156909395",
        "salefrom": {
            "_id": "682ac1bd2767ad8156909397",
            "storeid": "682ac1bd2767ad8156909395",
            "title": "RELIANCE SMART SUPERSTORE",
            "email": "sample@gmail.com",
             "image": settings?.saleProfileData?.image
              ?  settings.saleProfileData.image
              : "/assets/images/logo-light.png",
            "addressline1": "1st floor, 18/6",
            "district": "Kanniyakumari",
            "phone": "6384825800",
            "pincode": "629160",
            "state": "Tamil Nadu",
            "statecode": "33",
            "country": "INDIA",
            "fssai": "66688867767886",
            "addressline2": "Kalladithoppu,Neerody,Kollencode,KK",
            "cinnumber": "",
            "gstnumber": "27ABCDE1234F2Z5",
            "pannumber": "ABCDE1234F",
            "additionalPhone": "9751251871"
        },
        "saleprofileid": "682ac1bd2767ad8156909397",
        "isGroupedStock": true,
        "saleitems": [
            {
                "_id": "69c682692be3ec325254b394",
                "code": "26032725",
                "hsnsac": "8202",
                "title": "4\" BULLET BLACK PLAIN CUTTING BLADE",
                "note": "",
                "mrp": 13500,
                "saleprice": 13000,
                "soldprice": 13000,
                "taxpercentage": 18,
                "baseprice": 11017,
                "isLock": "SALEPRICE",
                "isStock": true,
                "quantity": 1,
                "imode": "PRODUCT",
                "itemNo": 1,
                "discount": 500,
                "taxamount": 1983,
                "sgstPercent": "9",
                "sgstAmount": 991,
                "cgstPercent": "9",
                "cgstAmount": 991,
                "igstPercent": "18",
                "igstAmount": 1983,
                "lineTotalMrp": 13500,
                "lineTotalSalePrice": 13000,
                "lineTotalSoldPrice": 13000,
                "lineTotalDiscount": 500,
                "lineTotalBasePrice": 11017,
                "lineTotalTaxAmount": 1983,
                "lineTotalSgstAmount": 991,
                "lineTotalCgstAmount": 991,
                "lineTotalIgstAmount": 1983,
                "lineGrandTotal": 13000,
                "stockInfo": {
                    "consumeId": "6a83cd37e7c6c990d813eac8",
                    "consumedFrom": [
                        {
                            "stockLId": "69d738085a9fd741590171b0",
                            "stockId": "69d738085a9fd741590171ae",
                            "productId": "69c682692be3ec325254b394",
                            "landingCost": 10500,
                            "consumedQuantity": 1,
                            "unitConfig": null,
                            "createdAt": "2026-04-09T05:24:24.808Z"
                        }
                    ]
                }
            },
            {
                "_id": "69b8cbc63dbe9436e2e92856",
                "code": "2603172",
                "hsnsac": null,
                "title": "Black berry",
                "note": "",
                "mrp": 42000,
                "saleprice": 42000,
                "soldprice": 42000,
                "taxpercentage": 0,
                "baseprice": 42000,
                "isLock": "SALEPRICE",
                "isStock": true,
                "quantity": 1,
                "imode": "PRODUCT",
                "unitConfig": {
                    "primaryUnitCode": "kg",
                    "stockScale": 10000
                },
                "isSecondaryUnit": false,
                "itemNo": 2,
                "discount": 0,
                "taxamount": 0,
                "sgstPercent": "0",
                "sgstAmount": 0,
                "cgstPercent": "0",
                "cgstAmount": 0,
                "igstPercent": "0",
                "igstAmount": 0,
                "lineTotalMrp": 42000,
                "lineTotalSalePrice": 42000,
                "lineTotalSoldPrice": 42000,
                "lineTotalDiscount": 0,
                "lineTotalBasePrice": 42000,
                "lineTotalTaxAmount": 0,
                "lineTotalSgstAmount": 0,
                "lineTotalCgstAmount": 0,
                "lineTotalIgstAmount": 0,
                "lineGrandTotal": 42000,
                "stockInfo": {
                    "consumeId": "6a83cd37e7c6c990d813eac9",
                    "consumedFrom": [
                        {
                            "stockLId": "69b8cbc73dbe9436e2e9285c",
                            "stockId": "69b8cbc73dbe9436e2e9285a",
                            "productId": "69b8cbc63dbe9436e2e92856",
                            "landingCost": 0,
                            "consumedQuantity": 1,
                            "unitConfig": {
                                "primaryUnitCode": "kg",
                                "stockScale": 10000
                            },
                            "createdAt": "2026-03-17T03:34:31.169Z"
                        }
                    ]
                }
            },
            {
                "_id": "69b0e27ddf20a7be4fa953a3",
                "code": "2603111",
                "hsnsac": null,
                "title": "Dove",
                "note": "",
                "mrp": 6000,
                "saleprice": 5500,
                "soldprice": 5500,
                "taxpercentage": 5,
                "baseprice": 5238,
                "isLock": "SALEPRICE",
                "isStock": true,
                "quantity": 1,
                "imode": "PRODUCT",
                "unitConfig": {
                    "primaryUnitCode": "box",
                    "secondaryUnitCode": "kg",
                    "conversion": 10,
                    "stockScale": 10000
                },
                "isSecondaryUnit": false,
                "itemNo": 3,
                "discount": 500,
                "taxamount": 262,
                "sgstPercent": "2.5",
                "sgstAmount": 131,
                "cgstPercent": "2.5",
                "cgstAmount": 131,
                "igstPercent": "5",
                "igstAmount": 262,
                "lineTotalMrp": 6000,
                "lineTotalSalePrice": 5500,
                "lineTotalSoldPrice": 5500,
                "lineTotalDiscount": 500,
                "lineTotalBasePrice": 5238,
                "lineTotalTaxAmount": 262,
                "lineTotalSgstAmount": 131,
                "lineTotalCgstAmount": 131,
                "lineTotalIgstAmount": 262,
                "lineGrandTotal": 5500,
                "stockInfo": {
                    "consumeId": "6a83cd37e7c6c990d813eaca",
                    "consumedFrom": [
                        {
                            "stockLId": "69b0e27ddf20a7be4fa953a9",
                            "stockId": "69b0e27ddf20a7be4fa953a7",
                            "productId": "69b0e27ddf20a7be4fa953a3",
                            "landingCost": 5000,
                            "consumedQuantity": 1,
                            "unitConfig": null,
                            "createdAt": "2026-03-11T03:33:17.362Z"
                        }
                    ]
                }
            },
            {
                "_id": "69d4db87616b70fca669873e",
                "code": "2604074",
                "hsnsac": null,
                "title": "Wire 5 inch",
                "note": "",
                "mrp": 49300,
                "saleprice": 49000,
                "soldprice": 49000,
                "taxpercentage": 5,
                "baseprice": 46667,
                "isLock": "SALEPRICE",
                "isStock": true,
                "quantity": 1,
                "imode": "PRODUCT",
                "unitConfig": {
                    "primaryUnitCode": "m",
                    "secondaryUnitCode": "cm",
                    "conversion": 100,
                    "stockScale": 10000
                },
                "isSecondaryUnit": false,
                "itemNo": 4,
                "discount": 300,
                "taxamount": 2333,
                "sgstPercent": "2.5",
                "sgstAmount": 1166,
                "cgstPercent": "2.5",
                "cgstAmount": 1166,
                "igstPercent": "5",
                "igstAmount": 2333,
                "lineTotalMrp": 49300,
                "lineTotalSalePrice": 49000,
                "lineTotalSoldPrice": 49000,
                "lineTotalDiscount": 300,
                "lineTotalBasePrice": 46667,
                "lineTotalTaxAmount": 2333,
                "lineTotalSgstAmount": 1166,
                "lineTotalCgstAmount": 1166,
                "lineTotalIgstAmount": 2333,
                "lineGrandTotal": 49000,
                "stockInfo": {
                    "consumeId": "6a83cd37e7c6c990d813eacb",
                    "consumedFrom": [
                        {
                            "stockLId": "69d4db87616b70fca6698743",
                            "stockId": "69d4db87616b70fca6698741",
                            "productId": "69d4db87616b70fca669873e",
                            "landingCost": 0,
                            "consumedQuantity": 1,
                            "unitConfig": {
                                "primaryUnitCode": "m",
                                "secondaryUnitCode": "cm",
                                "conversion": 100,
                                "stockScale": 10000
                            },
                            "createdAt": "2026-04-07T10:25:11.112Z"
                        }
                    ]
                }
            }
        ],
        "lastItemNo": 4,
        "totalItems": 4,
        "totalmrp": 110800,
        "totalsaleprice": 109500,
        "totalsoldprice": 109500,
        "totalbaseprice": 104922,
        "totaldiscount": 1300,
        "totaltaxamount": 4578,
        "grandtotal": 109500,
        "sgstamount": 2289,
        "cgstamount": 2289,
        "igstamount": 4578,
        "taxType": "IGST",
        "cashamount": 25000,
        "cashchange": 0,
        "cardamount": 12800,
        "cardchange": 0,
        "onlineamount": 2300,
        "onlinechange": 0,
        "upiamount": 0,
        "upichange": 0,
        "paylateramount": 69400,
        "paylaterchange": 0,
        "waveoffamount": 0,
        "waveoffchange": 0,
        "isPayLaterSettle": false,
        "changeamount": 0,
        "saleByStoreId": "682ac1bd2767ad8156909395",
        "saleby": {
            "_id": "682ac1bd2767ad8156909395",
            "accountid": "682abff670935fd61ef1f2fd",
            "stype": "MAIN",
            "title": "Demo Store",
            "email": "sample@gmail.com",
            "country": "INDIA",
            "countrycode": "IN",
            "timezone": "Asia/Kolkata",
            "utcoffset": "+05:30",
            "saleFromId": "682ac1bd2767ad8156909397"
        },
        "createdBy": {
            "_id": "682ac1bd2767ad8156909395",
            "accountid": "682abff670935fd61ef1f2fd",
            "stype": "MAIN",
            "title": "Demo Store",
            "email": "sample@gmail.com",
            "country": "INDIA",
            "countrycode": "IN",
            "timezone": "Asia/Kolkata",
            "utcoffset": "+05:30",
            "status": "ACTIVE",
            "saleFromId": "682ac1bd2767ad8156909397"
        },
        "updatedBy": {
            "_id": "682ac1bd2767ad8156909395",
            "accountid": "682abff670935fd61ef1f2fd",
            "stype": "MAIN",
            "title": "Demo Store",
            "email": "sample@gmail.com",
            "country": "INDIA",
            "countrycode": "IN",
            "timezone": "Asia/Kolkata",
            "utcoffset": "+05:30",
            "status": "ACTIVE",
            "saleFromId": "682ac1bd2767ad8156909397"
        },
        "status": "ACTIVE",
        "saleTrack": "ADDED",
        "saleVersion": 1,
        "consumeVersion": "CONSUMEV2",
        "paymentInfo": [
            {
                "mode": "CASH",
                "amount": 25000
            },
            {
                "mode": "CARD",
                "amount": 12800
            },
            {
                "mode": "ONLINE",
                "amount": 2300
            }
        ],
        "createdAt": "2026-08-18T03:10:46.949Z",
        "updatedAt": "2026-08-18T03:10:47.470Z",
        "__v": 0,
        "amountinwords": "One Thousand Ninety Five Rupees Only",
        "boxCashInfo": {
            "boxcashid": "6a83cd37e7c6c990d813ead5",
            "storeid": "682ac1bd2767ad8156909395",
            "mainStoreId": "682ac1bd2767ad8156909395",
            "cashdate": "2026-08-17T18:30:00.000Z",
            "cmode": "CASHIN",
            "title": "From Sale A262728",
            "description": "Paid: 250 - Change: 0",
            "amount": 25000,
            "denominationData": [],
            "trackid": "6a83cd36e7c6c990d813eabd",
            "trackmode": "SALE",
            "_id": "6a83cd37e7c6c990d813ead5"
        },
        "customerid": "68d267c2e75bff943d1be042",
        "paidamount": 109500,
        "paylaterInfo": {
            "mainStoreId": "682ac1bd2767ad8156909395",
            "storeid": "682ac1bd2767ad8156909395",
            "customerid": "68d267c2e75bff943d1be042",
            "paylaterAccountId": "68dca131afc5587316fe9dd9",
            "trackid": "6a83cd36e7c6c990d813eabd",
            "trackmode": "SALE",
            "paymode": "PAYOUT",
            "openamount": 10000,
            "amount": 69400,
            "closeamount": -59400,
            "description": "From New Sale - A262728. 4\" BULLET BLAC... (1 Qty) + 3 More Items",
            "paymentmode": "PAYLATER",
            "_id": "6a83cd37e7c6c990d813ead2",
            "createdAt": "2026-08-18T03:10:47.409Z",
            "updatedAt": "2026-08-18T03:10:47.409Z",
            "__v": 0
        },
        "saleto": {
            "_id": "68d267c2e75bff943d1be042",
            "groupid": "68d26968e75bff943d1be094",
            "name": "test",
            "phone": "9898788778",
            "email": "",
            "addressline1": "",
            "addressline2": "",
            "state": "Kerala",
            "statecode": "32",
            "district": "",
            "country": "",
            "pincode": "",
            "gstnumber": "",
            "pannumber": "",
            "cinnumber": "",
            "referenceid": "",
            "isPayLater": false
        },
        "totalPaid": 40100
    };
 const globalData = FormatedTemplateData(sale, storeSettings);
  const invoiceConfig = getInvoiceConfig(
    globalData,
    storeSettings,    
    settings,
  );

  const [selectHalfA4, setSelectHalfA4] = useState("HA4RET");
  const [selectInvoice, setSelectInvoice] = useState("INVPRO");
  const [selectTermal, setSelectTermal] = useState("TMLBAS");

  const [viewTheme,setViewTheme]=useState("")
  const [isViewData, setViewData] = useState(sale);
  const [isUploading, setIsUploading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [isImageModalOpen, seImageModalOpen] = useState(false);
  const [imageResult, setImgresult] = useState(null);

  const defaultImagePreview = useMemo(() => {
    return storeSettings.invoiceSettings?.signature
      ? uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature
      : "/assets/images/avatars/default.jpg";
  }, [storeSettings.invoiceSettings?.signature]);

  const [imagePreview, setImagePreview] = useState(defaultImagePreview);
  const [selectTermalOption,setSelectTermalOption]=useState("")
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedHalfA4Option, setSelectedHalfA4Option] = useState("");
  const handleClose = useCallback(() => {
    setViewModalOpen(false);
    setSelectInvoice("INVPRO");
    // setSelectTermal("TMLBAS");
  }, []);

  const handleThermalClose = useCallback(() => {
    setThermalViewModalOpen(false);
    setSelectTermal("TMLBAS");
  }, []);
    const handleHalfA4Close = useCallback(() => {
    setHalfA4ModalOpen(false);
    setSelectHalfA4("HA4RET");
  }, []);
console.log("sel",selectedOption)

  const [selectedTheme, setSelectedTheme] = useState({
    key: "DF",
    templateTheme: {
      primaryColor: "#f4f4f6",
      secondaryColor: "#ffffff",
      foregroundColor: "#242c6d",
      backgroundColor: "#f4f4f6",
      borderColor: "#c9c9d1",
    },
  });

  const handleImageClose = () => {
    setGlobelPopupOpen(false);
    seImageModalOpen(false);
  };
  const handleAddImage = async (image) => {
    if (image) {
      setImageFile(image);
      // setImagePreview(URL.createObjectURL(image));
      handleImageClose();
      await addImage(image);
    }
  };

  const handleRadioChange = async (option, color) => {
    // setSelectedOption(option);
    await handleSetTemplate(option, color);
  };

  const handleRadioTermal =(option,color)=>{
    setSelectTermalOption(option)
  }
  const handleRadioHalfA4Termal =(option,color)=>{
    setSelectedHalfA4Option(option)
  }
  const addtermsAndCondition = async () => {
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/termsandconditions`,
        {
          description: text,
        },
      );
      const result = response?.data?.results?.invoiceSettings;
      setText(result?.termsAndConditions);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            signature: result?.signature,
            termsAndConditions: result?.termsAndConditions,
            template: result.template,
          },
        },
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const deletetermsAndCondition = async () => {
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/termsandconditions`,
        {
          description: "",
        },
      );
      const result = response?.data?.results?.invoiceSettings;
      setText(result?.termsAndConditions);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            signature: result?.signature,
            termsAndConditions: result?.termsAndConditions,
            template: result.template,
          },
        },
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const addImage = async (image) => {
    if (!checkNetwork()) return;
    try {
      const formData = new FormData();
      if (image instanceof File) {
        formData.append("signature", image);
      } else {
        console.log("No image selected or wrong data type:", image);
      }

      const response = await AxiosInstance.patch(
        `module/storesettings/signature`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const result = response?.data?.results?.invoiceSettings;
      setImgresult(result?.signature);
      setImagePreview(uRLs.IMAGE_URL + result?.signature);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            termsAndConditions: result?.termsAndConditions,
            signature: result?.signature,
            template: result?.template,
          },
        },
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const removeImage = async () => {
    if (!checkNetwork()) return;
    try {
      const formData = new FormData();
      formData.append("signature", null);

      const response = await AxiosInstance.patch(
        `module/storesettings/signature`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const result = response?.data?.results?.invoiceSettings;

      updateSettings({
        storeSettings: {
          invoiceSettings: {
            termsAndConditions: result?.termsAndConditions,
            signature: result?.signature,
            template: result?.template,
          },
        },
      });
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSetTemplate = async (templateId,selectTermalOption,halfA4Id, templateTheme, show = true) => {
    if (!checkNetwork()) return;
    try {
      const fullTemplateId = `${templateId}AND${selectTermalOption}AND${halfA4Id}`;
      console.log("fill",fullTemplateId)
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateId:fullTemplateId,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id=results.templateId
      const words=id.split('AND')
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1])
      setSelectedHalfA4Option(words[2])
      setSelectedTheme(results);
      setImgresult(response.data?.results?.invoiceSettings?.signature);
      setViewModalOpen(false);
      setThermalViewModalOpen(false)
      setHalfA4ModalOpen(false)
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            ...(response.data?.results?.invoiceSettings?.signature
              ? {
                  signature: response.data?.results?.invoiceSettings?.signature,
                }
              : {}),
            termsAndConditions: terms,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleOpenImageModel = () => {
    setGlobelPopupOpen(true);
    seImageModalOpen(true);
  };

  useEffect(() => {
    if (storeSettings.invoiceSettings?.termsAndConditions?.length > 0) {
      setIsEditing(false);
    } else {
      setIsEditing(true);
    }
    setText(storeSettings.invoiceSettings?.termsAndConditions);
    const id=storeSettings?.invoiceSettings?.template?.templateId||""
    const words=id ? id?.split('AND'):[];

   

    setSelectedOption(words[0]??"INVPRO");
    setSelectTermalOption(words[1]??"TMLBAS");
 setSelectedHalfA4Option(words[2] ?? "HA4RET");
    if (storeSettings.invoiceSettings?.template?.templateTheme) {
      setSelectedTheme(storeSettings.invoiceSettings?.template);
    }
  }, []);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings?.termsAndConditions]);

  return (<>  
   <div className="card-header p-3 bg-light-core d-flex align-item-center justify-content-between rounded-top-2">
                    <h6 className={`mb-0 text-dark  `}>Invoice Settings</h6>
                    </div>
    <div className="bg-white p-4 rounded-bottom-2">
      <div className="row">
        <div className="page-breadcrumb d-flex align-items-center mb-3">
          <div className="breadcrumb-title pe-3">Template</div>
        </div>       
        {selectedOption && (
          <div className="col-3">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0 pb-1">
                <div className="pb-2 pt-0 d-flex justify-content-center fw-medium">
                  <span>A4 Template</span>
                </div>
                <div className="row px-3 d-flex justify-content-center">
                  {(selectedOption === "INVPRO"||selectedOption === "INVOICEONE")  && (
                    <InvoiceThumbnail
                      id="INVPRO"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVPRO",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVPRO");
                        setViewTheme("INVPRO")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail1
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                        downloadbtn={false}
                      />
                    </InvoiceThumbnail>
                  )}

                  {(selectedOption === "INVESS"||selectedOption === "INVOICETWO") && (
                    <InvoiceThumbnail
                      id="INVESS"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVESS",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVESS");
                        setViewTheme("INVESS")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail2
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                  {(selectedOption === "INVSTR"||selectedOption === "INVOICEFOUR") && (
                    <InvoiceThumbnail
                      id="INVSTR"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVSTR",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVSTR");
                        setViewTheme("INVSTR")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail4
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                    {(selectedOption === "INVCOM" ||selectedOption === "INVOICEFIVE") && (
                    <InvoiceThumbnail
                      id="INVCOM"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVCOM",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVCOM");
                        setViewTheme("INVCOM")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail5
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                         {(selectedOption === "INVSEV"||selectedOption === "INVOICESIX" )&& (
                    <InvoiceThumbnail
                      id="INVSEV"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVSEV",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVSEV");
                        setViewTheme("INVSEV")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail6
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                          {(selectedOption === "INVLEX" )&& (
                    <InvoiceThumbnail
                      id="INVLEX"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVLEX",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVLEX");
                        setViewTheme("INVLEX")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail7
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                  {(selectedOption === "INVPRM" )&& (
                    <InvoiceThumbnail
                      id="INVPRM"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVPRM",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVPRM");
                        setViewTheme("INVPRM")
                      }} 
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail8
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                  {/* {selectedOption === "INVSTR" && (
                    <InvoiceThumbnail
                      id="INVSTR"
                      isSelected
                      onSelect={() =>
                        handleRadioChange(
                          "INVSTR",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectInvoice("INVSTR");
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <InvoiceThumnail3
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )} */}
                </div>
                <div className="pt-1 text-primary badge pb-1 d-flex justify-content-center fw-medium">

                  <span>{selectedOption==="INVPRO"&&("Professional GST Invoice")}
                  {selectedOption==="INVESS"&&("Essential Invoice")}
                  {selectedOption==="INVSTR"&&("Structured Invoice")}
                  {selectedOption==="INVCOM"&&("Commercial Invoice")}
                  {selectedOption==="INVSEV"&&("Service Invoice")}
                   {selectedOption==="INVLEX"&&("Legend Executive")}
                   {selectedOption==="INVPRM"&&(" Prime Invoice")}</span>

                </div>
              </div>
            </div>
          </div>
        )}
{selectTermalOption && (
          <div className="col-3">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0 pb-1">
                <div className="pb-2 pt-0 d-flex justify-content-center fw-medium">
                  <span>Thermal Print</span>
                </div>
                <div className="row px-3 d-flex justify-content-center">
                  {(selectTermalOption === "TMLBAS"||selectTermalOption === "THERMALTWO") && (
                    <InvoiceThumbnail
                      id="TMLBAS"
                      isSelected
                      onSelect={() =>
                        handleRadioTermal(
                          "TMLBAS",
                          selectedTheme?.templateTheme
                        )
                      }
                      onPreview={() => {
                        setThermalViewModalOpen(true);
                        setSelectTermal("TMLBAS");
                        setViewTheme("TMLBAS")
                      }}
                      thunailclass="thermal-thumbnail"
                    >
                      <Thermal_1
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                        downloadbtn={false}
                        width={false}
                      />
                    </InvoiceThumbnail>
                  )}

{(selectTermalOption === "TMLMOD"||selectTermalOption === "THERMALONE") && (
                    <InvoiceThumbnail
                      id="TMLMOD"
                      isSelected
                      onSelect={() =>
                        handleRadioTermal(
                          "TMLMOD",
                          selectedTheme?.templateTheme
                        )
                      }
                      onPreview={() => {
                        setThermalViewModalOpen(true);
                        setSelectTermal("TMLMOD");
                        setViewTheme("TMLMOD")
                      }}
                      thunailclass="thermal-thumbnail"
                    >
                      <Thermal_2
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                        downloadbtn={false}
                      />
                    </InvoiceThumbnail>
                  )}
                </div>
                <div className="pt-1 text-primary badge pb-1 d-flex justify-content-center fw-medium">
                  <span>{selectTermalOption==="TMLBAS"&&("Basic Thermal")}
                  {selectTermalOption==="TMLMOD"&&("Modern Thermal")}</span>
                </div>
              </div>
            </div>
          </div>
        )}
          {selectedHalfA4Option && (
          <div className="col-3">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0 pb-1">
                <div className="pb-2 pt-0 d-flex justify-content-center fw-medium">
                  <span>HalfA4 Template</span>
                </div>
                <div className="row px-3 d-flex justify-content-center">
                  {(selectedHalfA4Option === "HA4RET") && (
                        //  {selectedHalfA4Option === "HA4RET" && (
                    <InvoiceThumbnail
                      id="HA4RET"
                      isSelected
                      onSelect={() =>
                        handleRadioHalfA4Termal(
                          "HA4RET",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setHalfA4ModalOpen(true);
                        setSelectHalfA4("HA4RET");
                        setViewTheme("HA4RET")
                      }}
                      thunailclass="invoiceHalfA4-thumbnail"
                    >
                      <HalfA4_1
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                     {(selectedHalfA4Option === "HA4SRT") && (
                        //  {selectedHalfA4Option === "HA4RET" && (
                    <InvoiceThumbnail
                      id="HA4SRT"
                      isSelected
                      onSelect={() =>
                        handleRadioHalfA4Termal(
                          "HA4SRT",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setHalfA4ModalOpen(true);
                        setSelectHalfA4("HA4SRT");
                        setViewTheme("HA4SRT")
                      }}
                      thunailclass="invoiceHalfA4-thumbnail"
                    >
                      <HalfA4_2
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                
                  {(selectedHalfA4Option === "HA4CMP") && (
                        //  {selectedHalfA4Option === "HA4RET" && (
                    <InvoiceThumbnail
                      id="HA4CMP"
                      isSelected
                      onSelect={() =>
                        handleRadioHalfA4Termal(
                          "HA4CMP",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setHalfA4ModalOpen(true);
                        setSelectHalfA4("HA4CMP");
                        setViewTheme("HA4CMP")
                      }}
                      thunailclass="invoiceHalfA4-thumbnail"
                    >
                      <HalfA4_3
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                    {(selectedHalfA4Option === "HA4CLS") && (
                        //  {selectedHalfA4Option === "HA4RET" && (
                    <InvoiceThumbnail
                      id="HA4CLS"
                      isSelected
                      onSelect={() =>
                        handleRadioHalfA4Termal(
                          "HA4CLS",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setHalfA4ModalOpen(true);
                        setSelectHalfA4("HA4CLS");
                        setViewTheme("HA4CLS")
                      }}
                      thunailclass="invoiceHalfA4-thumbnail"
                    >
                      <HalfA4_4
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                      />
                    </InvoiceThumbnail>
                  )}
                     {(selectedHalfA4Option === "HA4PRM") && (
                        //  {selectedHalfA4Option === "HA4RET" && (
                    <InvoiceThumbnail
                      id="HA4PRM"
                      isSelected
                      onSelect={() =>
                        handleRadioHalfA4Termal(
                          "HA4PRM",
                          selectedTheme?.templateTheme,
                        )
                      }
                      onPreview={() => {
                        setHalfA4ModalOpen(true);
                        setSelectHalfA4("HA4PRM");
                        setViewTheme("HA4PRM")
                      }}
                      thunailclass="invoiceHalfA4-thumbnail"
                    >                    
                       <HalfA4_5
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                        invoiceConfig={invoiceConfig}
                      />
                    </InvoiceThumbnail>
                  )}
                </div>
                <div className="pt-1 text-primary badge pb-1 d-flex justify-content-center fw-medium">
                  <span>{selectedHalfA4Option==="HA4RET"&&(" Retail Invoice")}
                    {selectedHalfA4Option==="HA4SRT"&&(" Standard Receipt")}
                    {selectedHalfA4Option==="HA4CMP"&&(" Compact Invoice")}
                    {selectedHalfA4Option==="HA4CLS"&&(" Classic Invoice")}
                    {selectedHalfA4Option === "HA4PRM" && "Premium Invoice"}
</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* <div className={selectedOption ? "col-9" : "col-12"}>
          <div className="card radius-10 mb-0">
            <div className="card-body px-0">
              <span className="ps-3 pb-2 pt-0 d-flex justify-content-between fw-medium">
                <span>Template's List</span>
              </span>
              <div className="row px-4 gap-5">
                <div
                  className={`invoice-thumbnail position-relative form-check custom-option
        custom-option-image custom-option-image-check
        cursor-pointer`}
                  onClick={() => {
                    setViewModalOpen(true);
                    setSelectInvoice("INVPRO");
                    setViewTheme("INVPRO")
                  }}
                >
                  <div className="invoice-scale">
                    <InvoiceThumnail1
                      isViewData={isViewData}
                      selectedTheme={selectedTheme}
                      selectedSize="INVOICE"
                    />
                  </div>
                </div>
                <div
                  className={`invoice-thumbnail position-relative form-check custom-option
        custom-option-image custom-option-image-check
        cursor-pointer`}
                  onClick={() => {
                    setViewModalOpen(true);
                    setSelectInvoice("INVESS");
                    setViewTheme("INVESS")
                  }}
                >
                  <div className="invoice-scale">
                    <InvoiceThumnail2
                      isViewData={isViewData}
                      selectedTheme={selectedTheme}
                      selectedSize="INVOICE"
                    />
                  </div>
                </div>
                <div
                  className={`invoice-thumbnail position-relative form-check custom-option
        custom-option-image custom-option-image-check
        cursor-pointer`}
                  onClick={() => {
                    setViewModalOpen(true);
                    setSelectInvoice("INVSTR");
                    setViewTheme("INVSTR")
                  }}
                >
                  <div className="invoice-scale">
                    <InvoiceThumnail4
                      isViewData={isViewData}
                      selectedTheme={selectedTheme}
                      selectedSize="INVOICE"
                    />
                  </div>
                </div>
                {/* <div
                  className={`invoice-thumbnail position-relative form-check custom-option
        custom-option-image custom-option-image-check
        cursor-pointer`}
                  onClick={() => {
                    setViewModalOpen(true);
                    setSelectInvoice("INVOICETHREE");
                    setViewTheme("INVOICETHREE")
                  }}
                >
                  <div className="invoice-scale">
                    <InvoiceThumnail3
                      isViewData={isViewData}
                      selectedTheme={selectedTheme}
                      selectedSize="INVOICE"
                    />
                  </div>
                </div> */}
              {/* </div>
            </div>
          </div>
        </div>  */}
      </div>
      {/* <div className="row pt-3">
        <div className="page-breadcrumb d-flex align-items-center mb-3">
          <div className="breadcrumb-title pe-3">Thermal Print Template</div>
        </div>
        {selectTermalOption && (
          <div className="col-3">
            <div className="card radius-10 mb-0">
              <div className="card-body px-0">
                <span className="ps-3 pb-2 pt-0 d-flex justify-content-between fw-medium">
                  <span>Selected Thermal Print</span>
                </span>
                <div className="row px-3 d-flex justify-content-center">
                  {selectTermalOption === "TMLBAS" && (
                    <InvoiceThumbnail
                      id="TMLBAS"
                      isSelected
                      onSelect={() =>
                        handleRadioTermal(
                          "TMLBAS",
                          selectedTheme?.templateTheme
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectTermal("TMLBAS");
                        setViewTheme("TMLBAS")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <Thermal_1
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                        downloadbtn={false}
                      />
                    </InvoiceThumbnail>
                  )}

{/* {selectTermalOption === "TMLMOD" && (
                    <InvoiceThumbnail
                      id="TMLMOD"
                      isSelected
                      onSelect={() =>
                        handleRadioTermal(
                          "TMLMOD",
                          selectedTheme?.templateTheme
                        )
                      }
                      onPreview={() => {
                        setViewModalOpen(true);
                        setSelectTermal("TMLMOD");
                        setViewTheme("TMLMOD")
                      }}
                      thunailclass="invoice-thumbnail"
                    >
                      <Thermal_2
                        isViewData={isViewData}
                        selectedTheme={selectedTheme}
                        selectedSize="INVOICE"
                        downloadbtn={false}
                      />
                    </InvoiceThumbnail>
                  )} */}
                {/* </div>
              </div>
            </div>
          </div>
        )} */}

        {/* <div className={selectTermalOption ? "col-9" : "col-12"}>
          <div className="card radius-10 mb-0">
            <div className="card-body px-0">
              <span className="ps-3 pb-2 pt-0 d-flex justify-content-between fw-medium">
                <span>Thermal's printer List</span>
              </span>
              <div className="row px-4 gap-5">
                <div
                  className={`invoice-thumbnail position-relative form-check custom-option
        custom-option-image custom-option-image-check
        cursor-pointer`}
                  onClick={() => {
                    setViewModalOpen(true);
                    setSelectTermal("TMLBAS");
                    setViewTheme("TMLBAS")
                  }}
                >
                  <div className="invoice-scale">
                    <Thermal_1
                      isViewData={isViewData}
                      selectedTheme={selectedTheme}
                      selectedSize="INVOICE"
                    />
                  </div>
                </div>
                {/* <div
                  className={`invoice-thumbnail position-relative form-check custom-option
        custom-option-image custom-option-image-check
        cursor-pointer`}
                  onClick={() => {
                    setViewModalOpen(true);
                    setSelectTermal("TMLMOD");
                    setViewTheme("TMLMOD")
                  }}
                >
                  <div className="invoice-scale">
                    <Thermal_2
                      isViewData={isViewData}
                      selectedTheme={selectedTheme}
                      selectedSize="INVOICE"
                    />
                  </div>
                </div> */}
              {/* </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="row">
        <div className="col-12">
          <div className="page-breadcrumb d-flex align-items-center my-3">
            <div className="breadcrumb-title pe-3">Theme Colors</div>
          </div>
          <div className="card radius-10 mb-0">
            <div className="card-body p-3">
              <span className="d-flex justify-content-between fw-medium mb-2">
                <span>Primary Color</span>
              </span>
              <div className="d-flex gap-2 ">
                {themes.map((opt) => (
                  <button
                    key={opt.key}
                    type="button"
                    className={`theme-btn d-flex align ${
                      selectedTheme?.templateTheme?.primaryColor ===
                      opt.templateTheme?.primaryColor
                        ? "active"
                        : ""
                    }`}
                    style={{
                      "--b-color": opt.templateTheme?.primaryColor,
                    }}
                    onClick={() => {
                      setSelectedTheme(opt);
                      handleSetTemplate(
                        selectedOption || "INVPRO",
                        opt?.templateTheme,
                        false
                      );
                    }}
                  >
                    <span
                      className="theme-square"
                      style={{
                        backgroundColor: opt.templateTheme?.primaryColor,
                      }}
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="row">
        <div className="col-12 col-md-7">
          <div className="page-breadcrumb d-flex align-items-center my-3">
            <div className="breadcrumb-title pe-3">Terms & Conditions</div>
          </div>
          <div className="card radius-10 mb-0">
            <div className="card-body p-3">
              {/* Header */}
              <span className="ps-2 d-flex justify-content-between fw-medium">
                <span>Add Terms & Conditions</span>
              </span>
              {/* <div className="d-flex px-2 mt-3">
                  <textarea
                    type="text"
                    autoComplete="off"
                    className="form-control"
                    value={newTerm}
                    onChange={(e) => setNewTerm(e.target.value)}
                    rows={5}
                  />
                  {newTerm.length > 0 && (

                    <div>
                    <button
                      className="btn btn-sm btn-primary ms-2 w-100"
                      onClick={() => newTerm && addTerm()}
                    >
                      <i className="bx bx-plus"></i>
                    </button>
                    <button
                    className="btn btn-sm btn-primary ms-2 w-100 mt-2"
                    onClick={() => newTerm && addTerm()}
                  >
                    <i className="bx bx bx-edit"></i>
                  </button>
                  <button
                    className="btn btn-sm btn-primary ms-2 w-100 mt-2"
                    onClick={() => newTerm && addTerm()}
                  >
                    <i className="bx bx-trash"></i>
                  </button>
                  </div>
                  )}
                </div> */}
              <div className="d-flex mt-3">
                <textarea
                  autoComplete="off"
                  className="form-control"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  rows={5}
                  disabled={!isEditing} // disable when saved
                />

                {text?.length > 0 && (
                  <div>
                    {/* When typing OR editing → show save button */}
                    {isEditing ? (
                      <button
                        className="btn btn-sm btn-success ms-2 w-100"
                        onClick={() => {
                          setIsEditing(false);
                          addtermsAndCondition();
                        }} // Save mode
                      >
                        <CheckIcon/>
                      </button>
                    ) : (
                      <>
                        {/* Edit Button */}
                        <button
                          className="btn btn-sm btn-primary ms-2 w-100"
                          onClick={() => setIsEditing(true)} // Enable editing
                        >
                          <EditBxIcon/>
                        </button>

                        {/* Delete Button */}
                        <button
                          className="btn btn-sm btn-danger ms-2 w-100 mt-2"
                          onClick={() => {
                            deletetermsAndCondition();
                            setIsEditing(true);
                          }}
                        >
                          <TrashIcon/>
                        </button>
                      </>
                    )}
                  </div>
                )}
              </div>

              {/* List Items */}
              {/* <div className="mt-3">
                  {terms.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex px-2 mb-2 align-items-center"
                    >
                      {!item.isEditing && (
                        <span className="me-1">{index + 1}.</span>
                      )}

                      {item.isEditing ? (
                        <input
                          type="text"
                          className="form-control"
                          value={item.editValue}
                          placeholder="Type terms And Conditions"
                          onChange={(e) => {
                            const updated = [...terms];
                            updated[index].editValue = e.target.value;
                            setTerms(updated);
                          }}
                          onKeyDown={(e) =>
                            e.key === "Enter" && saveEdit(index, item.editValue)
                          }
                        />
                      ) : (
                        <span className="flex-grow-1">{item.text}</span>
                      )}

                      {item.isEditing ? (
                        <button
                          className="btn btn-sm btn-success ms-2"
                          onClick={() => {
                            if (!item.editValue.trim()) {
                              deleteTerm(index);
                            } else {
                              saveEdit(index, item.editValue);
                            }
                          }}
                        >
                          <i className="bx bx-check"></i>
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm btn-primary ms-2"
                          onClick={() => enableEdit(index)}
                        >
                          <i className="bx bx-edit"></i>
                        </button>
                      )}

                      <button
                        className="btn btn-sm btn-danger ms-2"
                        onClick={() => deleteTerm(index)}
                      >
                        <i className="bx bx-trash"></i>
                      </button>
                    </div>
                  ))}
                </div> */}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-5">
          <div className="page-breadcrumb d-flex align-items-center my-3">
            <div className="breadcrumb-title pe-3">Signature</div>
          </div>
          <div className="card radius-10 mb-0">
            <div className="card-body p-3">
              <span className="ps-2 d-flex justify-content-between fw-medium">
                <span>Add Signature</span>
              </span>
              <div className="mt-3">
                <div>
                  <div
                    className="profile-img-container w-100"
                    onClick={handleOpenImageModel}
                  >
                    {imagePreview === "/assets/images/avatars/default.jpg" ? (
                      <div className="d-flex justify-content-center">
                        <img
                          id="logoimg"
                          className="avatar"
                          src={imagePreview}
                          alt="profile-img"
                          style={{
                            width: "130px",
                            // maxWidth: "100%",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "2px solid #ddd",
                          }}
                        />
                      </div>
                    ) : (
                      <img
                        id="logoimg"
                        className="avatar"
                        src={imagePreview}
                        alt="profile-img"
                        style={{
                          width: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                          borderRadius: "8px",
                          border: "2px solid #ddd",
                        }}
                      />
                    )}
                    {/* Hover Icon */}
                    <div
                      className="overlay-icon"
                      onClick={() =>
                        document.getElementById("logo_image_popup").click()
                      }
                    >
                      <PlusIcon/>
                    </div>
                  </div>
                </div>
                {imagePreview === "/assets/images/avatars/default.jpg" ? (
                  ""
                ) : (
                  <div className="d-flex justify-content-end">
                    <span>
                      <button
                        className="btn btn-sm btn-danger ms-2  mt-2"
                        onClick={() => {
                          removeImage();
                          setImagePreview("/assets/images/avatars/default.jpg");
                          setImageFile(null);
                        }}
                      >
                        <TrashIcon/>
                      </button>
                    </span>
                  </div>
                )}
                {/* Hidden Input */}
                <input
                  id="logo_image_popup"
                  onClick={handleOpenImageModel}
                  style={{ display: "none" }}
                  disabled={isUploading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {isImageModalOpen && (
        <AddSignature
          onClose={handleImageClose}
          data={imageFile}
          onAdd={handleAddImage}
        />
      )}
      {isViewModalOpen && (
        <InvoiceTempPreview
          isData={isViewData}
          onClose={handleClose}
          onDataChange={true}
          onAdd={handleSetTemplate}
          invoiceTheme={selectInvoice}
          termalTheme={selectTermalOption}
          halfA4Theme={selectedHalfA4Option}
          viewTheme={viewTheme}
        />
      )}
      {isThermalViewModalOpen && (
        <ThermalTempPreview
          isData={isViewData}
          onClose={handleThermalClose}
          onDataChange={true}
          onAdd={handleSetTemplate}
          invoiceTheme={selectedOption}
          termalTheme={selectTermal}
           halfA4Theme={selectedHalfA4Option}
          viewTheme={viewTheme}
        />
      )}

      {isHalfA4ModalOpen && (
        <InvoiceHalfA4TempPreview
          isData={isViewData}
          onClose={handleHalfA4Close}
          onDataChange={true}
          onAdd={handleSetTemplate}
          invoiceTheme={selectedOption}
          termalTheme={selectTermalOption}
           halfA4Theme={selectHalfA4} 
          viewTheme={viewTheme}
        />
      )}
      {/* {isViewModalOpen === "INVESS" && (
        <EssentialInvoice
          isData={isViewData}
          onClose={handleClose}
          onDataChange={true}
          onAdd={handleSetTemplate}
        />
      )} */}
    </div>
    </>
  );
};

export default InvoiceSettings;

 